import { PropsWithChildren } from 'react';

import { Tooltip } from './tooltip';
import { MaybeTooltipProps } from './tooltip.types';

/**
 * A component that conditionally wraps its children with a Tooltip based on the isEnabled prop.
 *
 * @param {MaybeTooltipProps} props - The props for the MaybeTooltip component.
 * @param {boolean} props.isEnabled - Determines whether to render the Tooltip.
 * @param {React.ReactNode} props.children - The content to be wrapped by the Tooltip if enabled.
 * @returns {React.ReactNode} The children wrapped in a Tooltip if isEnabled is true, otherwise just the children.
 */
export function MaybeTooltip({
  isEnabled,
  children,
  ...tooltipProps
}: PropsWithChildren<MaybeTooltipProps>) {
  if (!isEnabled) return children;
  return <Tooltip {...tooltipProps}>{children}</Tooltip>;
}
